import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import produce from "immer";

import useAssessmentLabel from "../../../hooks/useAssessmentLabel";
import { Assessment, SkinAnalysisAttribute } from "../../../interfaces/AssessmentInterfaces";
import SkinAnalysisPopUp from "./SkinAnalysisPopUp";
import { tl } from "../../../components/translate";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

interface SkinAnalysisProps {
  assessment: Partial<Assessment>;
  onChange: (value: SkinAnalysisAttribute[]) => void;
}

export const SkinAnalysis: React.FC<SkinAnalysisProps> = ({ assessment, onChange }) => {
  const assessmentLabels = useAssessmentLabel();
  const [showDialog, setShowDialog] = useState(false);

  const skinAnalysis = assessment.skinAnalysis || [];

  return (
    <Box className={styles.assessmentRow} height="auto" alignItems="flex-start">
      <Box className={styles.assessmentLabel} pt="4px">
        <Typography component="span" fontWeight="600">
          {assessmentLabels.skinAnalysis || "Skin Analysis"}
        </Typography>
      </Box>

      <Box className={styles.assessmentField}>
        {skinAnalysis.map((item, index) => (
          <Box key={item.dbKey || index} sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography>{item.name}:</Typography>
              <Typography sx={{ fontWeight: 600 }}>{item.reading}</Typography>
            </Box>
            <CloseIcon
              sx={{ cursor: "pointer" }}
              onClick={() => {
                const updated = produce(skinAnalysis, (draft) => {
                  draft.splice(index, 1);
                });
                onChange(updated);
              }}
            />
          </Box>
        ))}

        <Button
          onClick={() => setShowDialog(true)}
          size="small"
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            marginTop: skinAnalysis.length > 0 ? 1 : 0
          }}
        >
          {tl("assessment.addNew")}
        </Button>
      </Box>

      <SkinAnalysisPopUp
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        previousAttributes={skinAnalysis}
        onSave={onChange}
      />
    </Box>
  );
};

export default SkinAnalysis;
